"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var qrcode_react_1 = __importDefault(require("qrcode.react"));
var Icon_1 = __importDefault(require("./Icon"));
var Box_1 = __importDefault(require("./Box"));
var CenterContent = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
});
function FFQRCode(props) {
    var _a = props.size, size = _a === void 0 ? 128 : _a, _b = props.url, url = _b === void 0 ? '' : _b, _c = props.margin, margin = _c === void 0 ? 8 : _c, className = props.className;
    var qrCodeSize = size - margin * 2;
    return (react_1.default.createElement(Box_1.default, { className: className },
        react_1.default.createElement(CenterContent, { size: size, backgroundColor: "white" },
            react_1.default.createElement(qrcode_react_1.default, { value: url, size: qrCodeSize, level: "H", renderAs: "svg", 
                // use imageSettings to create a white background
                // and replace with FF Icon
                imageSettings: {
                    src: '',
                    height: qrCodeSize * 0.25,
                    width: qrCodeSize * 0.25,
                    excavate: true, // true to have white background for icon
                } }),
            react_1.default.createElement(Icon_1.default, { name: "ff-icon-logo", fontSize: qrCodeSize * 0.18 + "px", color: "black", position: "absolute" }))));
}
exports.default = FFQRCode;
